<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item :label="$t('表编号')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['meterId']" :placeholder="$t('请输入表编号')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('用户编号')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['userId']" :placeholder="$t('请输入用户编号')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('记录原来用户户型信息Id')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['oldUserHouseholdCode']" :placeholder="$t('请输入记录原来用户户型信息Id')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('记录原来用户类型编码')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['oldUserTypeCode']" :placeholder="$t('请输入记录原来用户类型编码')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('记录原来用户手机号')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['oldUserPhone']" :placeholder="$t('请输入记录原来用户手机号')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('记录原来用户价格编码')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['oldUserPriceCode']" :placeholder="$t('请输入记录原来用户价格编码')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('记录原来身份证号')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['oldUserIdNumber']" :placeholder="$t('请输入记录原来身份证号')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('记录原来用来标识是自然人 还是 企业')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['oldUserIdType']" :placeholder="$t('请输入记录原来用来标识是自然人 还是 企业')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('记录原来用户表计费起始读数')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['oldUserMeterStartNum']" :placeholder="$t('请输入记录原来用户表计费起始读数')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('记录原来用户开户时表读数')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['oldUserMeterOpenNum']" :placeholder="$t('请输入记录原来用户开户时表读数')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('记录原来用户优惠信息')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['oldUserFreeinfo']" :placeholder="$t('请输入记录原来用户优惠信息')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('记录原来用户开户时阀门开关状态 0无动作 1 开阀 2 关阀')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['oldUserValveOpenorclose']" :placeholder="$t('请输入记录原来用户开户时阀门开关状态 0无动作 1 开阀 2 关阀')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="remark" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea v-decorator="['remark']" rows="4" :placeholder="$t('请输入remark')"/>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">{{ $t('提 交') }}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  export default {
    name: 'MeterUserinfoTransferRecordForm',
    components: {
      JFormContainer,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/jeecg-charge/meter/meterUserinfoTransferRecord/add",
          edit: "/jeecg-charge/meter/meterUserinfoTransferRecord/edit",
          queryById: "/jeecg-charge/meter/meterUserinfoTransferRecord/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'meterId','userId','oldUserHouseholdCode','oldUserTypeCode','oldUserPhone','oldUserPriceCode','oldUserIdNumber','oldUserIdType','oldUserMeterStartNum','oldUserMeterOpenNum','oldUserFreeinfo','oldUserValveOpenorclose','createTime','createBy','remark'))
        })
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'meterId','userId','oldUserHouseholdCode','oldUserTypeCode','oldUserPhone','oldUserPriceCode','oldUserIdNumber','oldUserIdType','oldUserMeterStartNum','oldUserMeterOpenNum','oldUserFreeinfo','oldUserValveOpenorclose','createTime','createBy','remark'))
      },
    }
  }
</script>